import "../../kendo.button.js"; // Still required until kendo.ui is modularized
import "../../kendo.avatar.js";
import "../../kendo.icons.js";
import { inject } from "../../core/service-container";
import { HtmlService } from "../../core/services/html.service";
import { FileUtilsService } from "../../core/services/file-utils.service";
import { STYLES, REFERENCES, ICONS } from "../constants";
import type { IFile } from "../../upload";

declare const kendo: any;

/**
 * Renders an avatar element for a message author.
 */
export const renderAvatar = (
    url: string,
    altText?: string,
    htmlService = inject(HtmlService)
): string => {
    return new kendo.ui.Avatar("<div>", {
        type: "image",
        image: url,
        alt: htmlService.encode(altText ?? "")
    }).wrapper[0].outerHTML;
};

/**
 * Renders a typing indicator animation.
 */
export const renderTypingIndicator = (): string => {
    return `<div class="${STYLES.typingIndicator}">
        <span></span>
        <span></span>
        <span></span>
    </div>`;
};

/**
 * Renders a single file attachment item.
 * Uses small-sized buttons for menu/download actions per Chat v3 spec.
 */
export const renderFile = (
    file: IFile,
    closeButton: boolean,
    fileMenuButton = true,
    htmlService = inject(HtmlService),
    fileUtilsService = inject(FileUtilsService)
): string => {
    const closeButtonHtml = closeButton
        ? new kendo.ui.Button(`<button class="" ${REFERENCES.fileCloseButton}>`, {
            icon: ICONS.x,
            fillMode: "flat",
            size: "small"
        }).wrapper[0].outerHTML
        : "";

    // Use small size for file menu button
    const fileMenuButtonHtml = fileMenuButton && !closeButton
        ? new kendo.ui.Button(`<button class="${STYLES.menuButton}" ${REFERENCES.fileMenuButton}>`, {
            icon: ICONS.attachmentMenu,
            fillMode: "flat",
            size: "small"
        }).wrapper[0].outerHTML
        : "";

    return `<li class="${STYLES.file}" data-uid="${htmlService.encode(file.uid)}">
        ${kendo.ui.icon({ icon: fileUtilsService.getFileGroup(file.extension, true), size: "xlarge" })}
        <div class="${STYLES.fileInfo}">
            <span class="${STYLES.fileName}">${htmlService.encode(file.name)}</span>
            <span class="${STYLES.fileSize}">${htmlService.encode(fileUtilsService.getFileSizeMessage(file.size))}</span>
        </div>
        ${closeButtonHtml}
        ${fileMenuButtonHtml}
    </li>`;
};
